import NpmConfig from './NpmConfig';

export * from './types';
export default NpmConfig;
